import { useOutletContext } from 'react-router-dom'

import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import {
  useFilter,
  useNewlyAddedFilters,
} from 'modules/performance_process/components/review/show/Filters/context'
import { useNewPerformanceModuleContext } from 'modules/performance_process/pages/ReviewsRootPage'
import { ReviewOverviewOutletContext } from 'modules/performance_process/pages/reviews/show/overview'

export const AgreementStatusFilter = () => {
  const { reviewProcess } = useOutletContext<ReviewOverviewOutletContext>()
  const { value, setValue } = useFilter('agreementStatus')
  const { newlyAddedFilters } = useNewlyAddedFilters()
  const { isAgreementDocumentEnabled } = useNewPerformanceModuleContext()

  if (!reviewProcess.agreementsConfiguration.enabled) return null

  return (
    <Filter.SingleChoice
      label={i18n.t('performance_process.agreements.filters.status.title')}
      value={value}
      options={[
        {
          label: isAgreementDocumentEnabled
            ? i18n.t('performance_process.agreements.filters.confirmed')
            : i18n.t('performance_process.agreements.filters.signed'),
          value: 'hassignedagreement',
        },
        {
          label: i18n.t('performance_process.agreements.filters.pending'),
          value: 'haspendingagreement',
        },
        {
          label: i18n.t('performance_process.agreements.filters.not_initiated'),
          value: 'notinitiated',
        },
      ]}
      onValueChange={setValue}
      defaultOpen={newlyAddedFilters.includes('agreementStatus')}
    />
  )
}
